import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { AUTH_TOKEN } from '../../../../environments';
import { moduleName } from '../../moduleInfo';
import { getFinanceManagementTableRoute } from '../../utils/apiRoutes';

export const getFinanceManagementTableAsync = createAsyncThunk(
  `${moduleName}/getFinanceManagementTableAsync`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getFinanceManagementTableRoute(),
      headers: {
        Authorization: AUTH_TOKEN,
      },
      params: {
        ...payload,
      },
    });
    const data = response.data;
    return data;
  }
);

const managementAppFinanceSlice = createSlice({
  name: `${moduleName}/finance-management`,
  initialState: {
    loading: false,
    mgmentFinanceTableData: null,
    mgmentFinanceTableCount: null,
  },
  reducers: {
    storeDashboardSchoolId: (state, action) => {
      state.schoolId = action.payload;
    },
  },
  extraReducers: {
    [getFinanceManagementTableAsync.pending]: (state) => {
      state.loading = true;
    },
    [getFinanceManagementTableAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.mgmentFinanceTableCount = action.payload.count;
      state.mgmentFinanceTableData = action.payload.data;
    },
    [getFinanceManagementTableAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { storeDashboardSchoolId } = managementAppFinanceSlice.actions;

export default managementAppFinanceSlice.reducer;
